/* wle:auto-imports:start */
import {WeaponComponent} from './js/components/weapon-component.js';
/* wle:auto-imports:end */

export default function (engine) {
    /* wle:auto-register:start */
engine.registerComponent(WeaponComponent);
/* wle:auto-register:end */
}
